import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconServer({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 24}
      width={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.88459V3.43003C0 3.43003 1.18778 0 11.7429 0C22.2979 0 23.9175 3.10387 23.9175 3.43003V7.86323C23.9175 7.86323 22.8336 11.3524 12.3495 11.3524C1.86536 11.3524 0 8.5765 0 7.88459ZM0.228953 15.8468C0.228953 15.8468 0.0302734 15.9025 0.0302734 16.387V20.4775C0.0302734 20.4775 1.09875 23.9563 11.973 23.9563C22.8472 23.9563 23.9999 20.5085 23.9999 20.5085V16.349C23.9999 15.9055 23.7464 15.8241 23.7464 15.8241C23.7464 15.8241 22.2859 18.9174 12.0238 18.9174C1.76173 18.9174 0.228953 15.8468 0.228953 15.8468ZM0.0302734 10.0326C0.0302734 9.54815 0.228953 9.49241 0.228953 9.49241C0.228953 9.49241 1.76173 12.563 12.0238 12.563C22.2859 12.563 23.7464 9.46973 23.7464 9.46973C23.7464 9.46973 23.9999 9.55117 23.9999 9.99461V14.1542C23.9999 14.1542 22.8472 17.6019 11.973 17.6019C1.09875 17.6019 0.0302734 14.1231 0.0302734 14.1231V10.0326Z"
        fill={color || "#509EE3"}
      />
    </svg>
  );
}
